import {
  AccessDenied,
  DisplayErrors,
  FeatureToggleList as FeatureToggleListComponent,
} from '@verifime/components';
import { z } from 'zod';

import { Stack, Typography } from '@mui/material';
import { apiSchemas } from '@verifime/api-definition';
import tokens from '@verifime/design-tokens';
import { TFeatureToggleConfigWithResolvedValue } from '@verifime/utils';
import { hooksApi } from './api';
import { useUser } from './UserContext';

export const BackendFeatureToggleList = () => {
  const { data: featureToggles, isLoading, error } = hooksApi.useGetV1featuretoggles();
  const { state: userState } = useUser();

  if (userState.status !== 'authenticated' || !userState.isAdmin) {
    return <AccessDenied />;
  }

  return (
    <Stack gap={tokens.spacingBase}>
      {isLoading && <Typography variant="body1">Loading feature toggles...</Typography>}
      {error && <DisplayErrors errors={[{ message: error.message }]} />}
      {featureToggles && featureToggles.length > 0 && (
        <FeatureToggleListComponent
          title="Backend Feature Toggles"
          togglesWithConfig={buildBackendFeatureToggle(featureToggles)}
        />
      )}
    </Stack>
  );
};

function buildBackendFeatureToggle(
  toggles: z.infer<typeof apiSchemas.FeatureToggleStatus>[],
): TFeatureToggleConfigWithResolvedValue {
  return toggles.reduce((acc, toggle) => {
    acc[toggle.key] = {
      key: toggle.key,
      resolvedValue: toggle.enabled,
    };
    return acc;
  }, {} as TFeatureToggleConfigWithResolvedValue);
}
